var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoDarkOrange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00016 2.35865C4.88471 2.35865 2.35914 4.88422 2.35914 7.99967C2.35914 11.1151 4.88471 13.6407 8.00016 13.6407C11.1156 13.6407 13.6412 11.1151 13.6412 7.99967C13.6412 4.88422 11.1156 2.35865 8.00016 2.35865ZM1.3335 7.99967C1.3335 4.31778 4.31826 1.33301 8.00016 1.33301C11.6821 1.33301 14.6668 4.31778 14.6668 7.99967C14.6668 11.6816 11.6821 14.6663 8.00016 14.6663C4.31826 14.6663 1.3335 11.6816 1.3335 7.99967ZM7.48734 5.26463C7.48734 4.98141 7.71694 4.75181 8.00016 4.75181H8.007C8.29022 4.75181 8.51982 4.98141 8.51982 5.26463C8.51982 5.54785 8.29022 5.77745 8.007 5.77745H8.00016C7.71694 5.77745 7.48734 5.54785 7.48734 5.26463ZM6.80358 7.99967C6.80358 7.71645 7.03318 7.48685 7.3164 7.48685H8.00016C8.28339 7.48685 8.51298 7.71645 8.51298 7.99967V10.2219H8.68392C8.96715 10.2219 9.19674 10.4515 9.19674 10.7347C9.19674 11.0179 8.96715 11.2475 8.68392 11.2475H8.00016C7.71694 11.2475 7.48734 11.0179 7.48734 10.7347V8.5125H7.3164C7.03318 8.5125 6.80358 8.2829 6.80358 7.99967Z",
    fill: "#6B4924"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoDarkOrange);
export default __webpack_public_path__ + "static/media/info-dark-orange.345b6b0466594c74044e5f77fcc78980.svg";
export { ForwardRef as ReactComponent };